/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Button } from 'react-bootstrap';
import Flex from '../Flex';

export const AdvanceTablePagination = ({
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  pageCount,
  pageIndex,
  gotoPage
}) => {
  return (
    <Flex alignItems="center" justifyContent="center">
      <Button
        size="sm"
        variant="falcon-default"
        onClick={() => previousPage()}
        className={classNames({ disabled: !canPreviousPage })}
      >
        <FontAwesomeIcon icon="chevron-left" />
      </Button>
      <ul className="pagination mb-0 mx-2">
        {(() => {
          const maxVisible = 5;
          let pages = [];

          if (pageCount <= maxVisible) {
            pages = Array.from({ length: pageCount }, (_, i) => i);
          } else {
            let start = Math.max(0, pageIndex - 2);
            let end = start + maxVisible - 1;
            if (end >= pageCount) {
              end = pageCount - 1;
              start = end - maxVisible + 1;
            }
            // Always include first page
            if (start > 0) {
              pages.push(0);
              if (start > 1) pages.push('start-ellipsis');
            }
            for (let i = start; i <= end; i++) {
              if (!pages.includes(i)) pages.push(i);
            }
            // Always include last page
            if (end < pageCount - 1) {
              if (end < pageCount - 2) pages.push('end-ellipsis');
              pages.push(pageCount - 1);
            }
          }

          return pages.map((page, index) =>
            typeof page === 'string' ? (
              <li key={page} className="d-flex align-items-center mx-1">
                <span className="text-muted">&hellip;</span>
              </li>
            ) : (
              <li key={page} className={classNames({ active: pageIndex === page })}>
                <Button
                  size="sm"
                  variant="falcon-default"
                  className={classNames('page', {
                    'me-2': index + 1 !== pages.length
                  })}
                  onClick={() => gotoPage(page)}
                >
                  {page + 1}
                </Button>
              </li>
            )
          );
        })()}
      </ul>
      <Button
        size="sm"
        variant="falcon-default"
        onClick={() => nextPage()}
        className={classNames({ disabled: !canNextPage })}
      >
        <FontAwesomeIcon icon="chevron-right" />
      </Button>
    </Flex>
  );
};

export default AdvanceTablePagination;
